"use strict";

exports.__esModule = true;
exports["default"] = exports.ArrowIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _animations = require("@qc-modules/animations");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["isOpen"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ArrowIcon = (0, _styledComponents["default"])(function (_ref) {
  var isOpen = _ref.isOpen,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, props);
}).withConfig({
  displayName: "accordion-item__ArrowIcon",
  componentId: "sc-1y3kuse-0"
})(["", ";transform:rotate(", "deg);svg{width:100%;height:100%;fill:inherit;}"], (0, _styles.transitionEase)("0.25s", ["transform"]), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? "-180" : "0";
});
exports.ArrowIcon = ArrowIcon;
var AccordionItemContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "accordion-item__AccordionItemContainer",
  componentId: "sc-1y3kuse-1"
})(["> div{width:100%;}"]);
var propTypes = {
  children: _propTypes.node,
  glyph: _propTypes.node,
  glyphSize: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),
  id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  isOpen: _propTypes.bool,
  label: _propTypes.node,
  labelFont: (0, _propTypes.shape)({
    color: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
    fontSize: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),
    fontWeight: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),
    letterSpacing: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
    lineHeight: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string])
  }),
  onItemClick: _propTypes.func
};

var AccordionItem = function AccordionItem(_ref3) {
  var children = _ref3.children,
      glyphSize = _ref3.glyphSize,
      glyph = _ref3.glyph,
      id = _ref3.id,
      isOpen = _ref3.isOpen,
      label = _ref3.label,
      labelFont = _ref3.labelFont,
      onItemClick = _ref3.onItemClick;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "flex-start",
    flexDirection: "column",
    mb: [0, 0, 2],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    cursor: "pointer",
    "data-test-id": "accordion-label",
    justifyContent: "space-between",
    onClick: function onClick(event) {
      return onItemClick(id, event);
    },
    px: [3, 3, 0],
    py: [2, 2, 1],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, labelFont, label), /*#__PURE__*/_react["default"].createElement(ArrowIcon, {
    cursor: "pointer",
    "data-test": "accordion-label-icon",
    fill: "body-grey",
    height: glyphSize,
    isOpen: isOpen,
    width: glyphSize
  }, glyph)), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    "data-test": "accordion-items",
    overflow: "hidden",
    position: "relative",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_animations.TransitionHeight, {
    alwaysShowInDom: true,
    enterDuration: 0.25,
    exitDuration: 0.2,
    show: isOpen
  }, /*#__PURE__*/_react["default"].createElement(AccordionItemContainer, {
    display: "none",
    flex: "1 0 auto",
    px: [3, 3, 0],
    width: 1
  }, children))));
};

AccordionItem.propTypes = propTypes;
AccordionItem.displayName = "Modules.AccordionItem";
var _default = AccordionItem;
exports["default"] = _default;